import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IAddPatientReq,IPatientRes, IPatientResNew} from './index.type';
// { patientId }: { patientId: string  }
const useAddPatient = ({ patientId }: { patientId: string  }) => {
  const url = patientId ?  `/rtm/patient-enrollment?patientId=${patientId}` : `/rtm/patient-enrollment`;
  const method = patientId ? 'PUT' : 'POST'; 
  const { loading: addPatientLoading , makeApiCall } = useApi({ url, method });

  const addPatient = async (formData: IAddPatientReq) => {
    const trimmedFormData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.trim() : value,
      ]),
    ) as IAddPatientReq;
    const { response, error } = await makeApiCall<IAddPatientReq, IPatientResNew>(trimmedFormData);

    if (response?.status === 'success') {
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to add patient. Please verify patient details and try again.');
      return { status: 'fail' };
    }
  };

  return {
    addPatientLoading,
    addPatient,
  };
};

export default useAddPatient;
